import { ActionCreator } from 'redux';
import { Pool, IPAddress } from '@dev/ee-api/ee-api-models';
import {
    LoadPoolsAction,
    LoadPoolsErrorAction,
    LoadPoolsSuccessAction,
    AddPurchaseInfoAction,
    PurchaseInfo,
    DeletePurchaseInfoAction,
    AddNewPoolAction,
    AddNewPoolSuccessAction,
    AddNewPoolsErrorAction,
    UpdatePoolAction,
    UpdatePoolSuccessAction,
    UpdatePoolErrorAction,
    DeletePoolAction,
    DeletePoolSuccessAction,
    DeletePoolErrorAction,
    LoadAllIPsAction,
    LoadAllIPsSuccessAction,
    MoveIPToPoolAction,
    MoveIPToPoolSuccessAction,
    LoadAllIPsErrorAction,
    MoveIPToPoolErrorAction,
} from './types';

export const LoadPools: ActionCreator<LoadPoolsAction> = (): LoadPoolsAction => ({
    type: '@@pools/FETCH_POOLS',
    payload: {
        poolsLoading: true,
    },
});
export const LoadPoolsSuccess: ActionCreator<LoadPoolsSuccessAction> = (pools: Pool[]): LoadPoolsSuccessAction => ({
    type: '@@pools/FETCH_POOLS_SUCCESS',
    payload: {
        poolsLoading: false,
        ipPools: pools,
    },
});
export const LoadPoolsError: ActionCreator<LoadPoolsErrorAction> = (): LoadPoolsErrorAction => ({
    type: '@@pools/FETCH_POOLS_ERROR',
});
export const AddPurchaseInfo: ActionCreator<AddPurchaseInfoAction> = (purchaseInfo: PurchaseInfo) => ({
    type: '@@pools/ADD_PURCHASE_INFO',
    payload: {
        purchaseInfo,
    },
});
export const DeletePurchaseInfo: ActionCreator<DeletePurchaseInfoAction> = (): DeletePurchaseInfoAction => ({
    type: '@@pools/DELETE_PURCHASE_INFO',
});
export const AddNewPool: ActionCreator<AddNewPoolAction> = (name: string, description: string): AddNewPoolAction => ({
    type: '@@pools/ADD_NEW_POOL',
    payload: {
        name,
        description,
    },
});
export const AddNewPoolSuccess: ActionCreator<AddNewPoolSuccessAction> = (pools: Pool[]): AddNewPoolSuccessAction => ({
    type: '@@pools/ADD_NEW_POOL_SUCCESS',
    payload: {
        ipPools: pools,
    },
});
export const AddNewPoolError: ActionCreator<AddNewPoolsErrorAction> = (): AddNewPoolsErrorAction => ({
    type: '@@pools/ADD_NEW_POOL_ERROR',
});
export const UpdatePool: ActionCreator<UpdatePoolAction> = (oldName: string, name: string, description: string): UpdatePoolAction => ({
    type: '@@pools/UPDATE_POOL',
    payload: {
        oldName,
        name,
        description,
    },
});
export const UpdatePoolSuccess: ActionCreator<UpdatePoolSuccessAction> = (pools: Pool[]): UpdatePoolSuccessAction => ({
    type: '@@pools/UPDATE_POOL_SUCCESS',
    payload: {
        ipPools: pools,
    },
});
export const UpdatePoolError: ActionCreator<UpdatePoolErrorAction> = (): UpdatePoolErrorAction => ({
    type: '@@pools/UPDATE_POOL_ERROR',
});
export const DeletePool: ActionCreator<DeletePoolAction> = (poolName: string): DeletePoolAction => ({
    type: '@@pools/DELETE_POOL',
    payload: {
        poolName,
    },
});
export const DeletePoolSuccess: ActionCreator<DeletePoolSuccessAction> = (pools: Pool[]): DeletePoolSuccessAction => ({
    type: '@@pools/DELETE_POOL_SUCCESS',
    payload: {
        ipPools: pools,
    },
});
export const DeletePoolError: ActionCreator<DeletePoolErrorAction> = (): DeletePoolErrorAction => ({
    type: '@@pools/DELETE_POOL_ERROR',
});
export const LoadAllIPs: ActionCreator<LoadAllIPsAction> = (): LoadAllIPsAction => ({
    type: '@@pools/LOAD_ALL_IPS',
});
export const LoadAllIPsSuccess: ActionCreator<LoadAllIPsSuccessAction> = (ips: IPAddress[]): LoadAllIPsSuccessAction => ({
    type: '@@pools/LOAD_ALL_IPS_SUCCESS',
    payload: {
        ips,
    },
});
export const LoadAllIPsError: ActionCreator<LoadAllIPsErrorAction> = (): LoadAllIPsErrorAction => ({
    type: '@@pools/LOAD_ALL_IPS_ERROR',
});
export const MoveIPToPool: ActionCreator<MoveIPToPoolAction> = (ip: string, targetPool: string): MoveIPToPoolAction => ({
    type: '@@pools/MOVE_IP_TO_POOL',
    payload: {
        ip,
        targetPool,
    },
});
export const MoveIPToPoolSuccess: ActionCreator<MoveIPToPoolSuccessAction> = (ips: IPAddress[]): MoveIPToPoolSuccessAction => ({
    type: '@@pools/MOVE_IP_TO_POOL_SUCCESS',
    payload: {
        ips,
    },
});
export const MoveIPToPoolError: ActionCreator<MoveIPToPoolErrorAction> = (): MoveIPToPoolErrorAction => ({
    type: '@@pools/MOVE_IP_TO_POOL_ERROR',
});
